<template>
  <div class="OnlineOffice">
    <es-dropdown :popStyle="{width: '230px', marginTop:'16px'}" :pushUp="'.header|#online-office-button'" position="right" >
      <a id="online-office-button" class="button is-info is-large">
        <span>{{ $t("links.onlineTransactions") }}</span>
        <span class="icon is-small">
          <i class="fa fa-angle-down"></i>
        </span>
      </a>               
      <div slot="content" class="menu-content">
        <a @click="openLogin">
          <button class="button is-info is-large is-fullwidth online-btn">{{ (showAccount) ? $t("buttons.personal") : $t("buttons.account") }}</button>
        </a>
        <!-- <a v-if="showCorporate" @click="openLoginCorporate">
          <button class="button is-primary is-large is-fullwidth online-btn">{{ $t("buttons.corporate") }}</button>
        </a> -->
        <template v-if="pageReady">
          <a rel="noreferrer" v-if="getOnlineOfficeItem('agency')" :href="getOnlineOfficeItem('agency').Url" target="_blank">
            <button class="button is-light is-large is-fullwidth online-btn">{{ $t("buttons.agency") }}</button>
          </a>
          <div class="online-title">{{ $t("texts.providerOperations") }}</div>
          <div class="online-item">
            <a rel="noreferrer" v-if="getOnlineOfficeItem('claimManagementSystem')" :href="getOnlineOfficeItem('claimManagementSystem').Url" target="_blank">{{ $t("links.claimManagementSystem") }}</a>
          </div>
          <div class="online-item">
            <a rel="noreferrer" v-if="getOnlineOfficeItem('partOrderModule')" :href="getOnlineOfficeItem('partOrderModule').Url" target="_blank">{{ $t("links.partOrderModule") }}</a>
          </div>
        </template>
      </div>
    </es-dropdown>
  </div>
</template>
<script>
import Login from '@/shared/widget/header/login'
import { vueSlideoutPanelService } from 'vue2-slideout-panel'
import EsDropdown from '@/shared/components/es-dropdown-hover'
import service from '@/service'
export default {
  name: 'OnlineOffice',
  components: {
    EsDropdown, Login
  },
  data () {
    return {
      pageReady: false,
      trace: null,
      onlineItems: [{
        'Name': 'Acente',
        'Url': 'https://acente.eurekosigorta.com.tr/',
        'Key': 'agency'
      },
      {
        'Name': 'Hasar Yönetim Sistemi',
        'Url': 'https://otohasar.eurekosigorta.com.tr/loginfrm.php',
        'Key': 'claimManagementSystem'
      },
      {
        'Name': 'Parça Sipariş Modülü',
        'Url': 'https://siparis.eurekosigorta.com.tr/loginfrm.php',
        'Key': 'partOrderModule'
      }]
    }
  },
  mounted () {
    var self = this
    service.customer.trace(self, self.eventHub).then(function (data) {
      self.trace = data
    })
    self.getOnlineOfficeItems()
  },
  methods: {
    openLogin: function () {
      // if (this.trace !== null && this.trace.webbranch === 'on') {
      var widthOfBody = document.body.clientWidth
      vueSlideoutPanelService.show({
        component: Login,
        width: widthOfBody,
        props: {
          headerTheme: 'light'
        }
      })
      // } else {
      //   window.open('https://isube.eurekosigorta.com.tr/ESInternetApplication/esinternet/InitLogin', 'Eureko', 'width=950,height=650,resizable=yes', false)
      // }
    },
    openLoginCorporate: function () {
      window.open('https://isube.eurekosigorta.com.tr/ESInternetApplication/esinternet/InitLoginCorporate', 'Eureko', 'width=950,height=650,resizable=yes', false)
    },
    getOnlineOfficeItems: function () {
      var self = this
      service.content.onlineBranchUrls(self).then(function (response) {
        if (response !== null) {
          self.onlineItems = response.data.commonurls
        }
        self.pageReady = true
      })
    },
    getOnlineOfficeItem: function (itemKey) {
      return this.onlineItems.find(item => item.Key === itemKey)
    }
  },
  computed: {
    showAccount: function () {
      return this.showCorporate
    },
    showCorporate: function () {
      return !(this.trace !== null && this.trace.webbranch === 'on')
      // return !(window.location.hostname.indexOf('testv2') === 0 || window.location.hostname.indexOf('testv3') === 0 || window.location.hostname.indexOf('localhost') === 0)
    }
  }
}
</script>
<style scoped>
#online-office-button {
  height: 44px;
}
.active .is-info {
  background-color: var(--btn-info-active);
}
.menu-content {
  padding:24px 30px;
}
.menu-content button {
  margin: 12px auto; 
}
.online-title {
  font-size: 0.875em;
  font-weight: 500;
  letter-spacing: -0.3px;
  color: var(--text-color1);
  padding: 15px 0;
}
.online-item {
  border-top:1px solid var(--border-color1);
  padding: 10px 0;
  font-size: 0.875em;
  line-height: 1.29;
  letter-spacing: -0.3px;
}
.online-item a {
  color: var(--text-color9);
}
</style>


// WEBPACK FOOTER //
// src/desktop/widget/header/onlineOffice.vue